import type { AnalyticsAdapter } from '@/adapters/analytics/types';

const createUserAwareAnalyticsAdapter = (
  analytics: AnalyticsAdapter,
  getUserId: () => string | null | undefined,
  getAccountId: () => string | null | undefined,
): AnalyticsAdapter => ({
  track: (event, params) => {
    const userId = getUserId();
    const accountId = getAccountId();

    analytics.setUserProperties?.({
      digima_user_id: userId != null ? String(userId) : null,
      account_id: accountId != null ? String(accountId) : null,
    });
    analytics.track(event, params);
  },
});

export { createUserAwareAnalyticsAdapter };
